import React, { InputHTMLAttributes, useEffect, useRef, useState } from 'react'
import { useModal } from "../hooks/useState"
import { submitRegistro } from "../components/layout/sendForm"
import { ValidateForm } from '../components/layout/validateForm'
import { defPath, fetchPath } from '../config/defPath'
import ValidateToken from "../components/layout/validateToken"

window.dataLayer = window.dataLayer || [];

const urls = {
  login: '/estadio-aguila/iniciar-sesion',
}

function App() {
  const [isDisabledButton, setIsDisabledButton] = React.useState(false)

  // const setValueDate = () => {
  //   const birthdate = document.querySelector('#date_birthday') as HTMLElement
  //   const current = new Date()
  //   const day = current.getDate()
  //   const month = current.getMonth()
  //   const year = current.getFullYear()

  //   // birthdate.setAttribute('value', `${year - 18}-${month + 1}-${day}`)
  //   birthdate.setAttribute('min', `${year - 70}-${month + 1}-${day}`)
  //   birthdate.setAttribute('max', `${year - 18}-${month + 1}-${day}`)
  // }

  const showPass = () => {
    const eyeButton = document.querySelectorAll('.eye') as any

    eyeButton.forEach((button: any) => {
      button.addEventListener('click', function () {
        let parent = button.parentNode
        let input = parent.querySelector('input')

        if (input.type == "password") {
          input.type = "text";
        }

        else {
          input.type = "password";
        }
      })
    });
  }
  const sendDatalayerRegistro = () => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Register',
      'event_action': 'Submit',
      'event_label': 'Register Submit',
    });
  }

  const gettpyc = async () => {
    const res = await fetch(`${fetchPath}/aguila/loyalty/tycpyp`)
    const data = await res.json()
    const pyp = document.querySelector("#pyp") as HTMLAnchorElement,
      tyc = document.querySelector("#tyc-link") as HTMLAnchorElement,
      title = document.querySelector("#title-register") as HTMLAnchorElement,
      subtitle = document.querySelector("#sub-register") as HTMLAnchorElement,
      btnregister = document.querySelector("#btn-register") as HTMLAnchorElement


    if (data.data) {

      pyp.innerHTML = data.data.pyp.value
      tyc.innerHTML = data.data.tyc.value
      title.innerHTML = data.data.title.value
      subtitle.innerHTML = data.data.subtitle.value
      btnregister.innerHTML = data.data.btn
      window.sessionStorage.setItem('TUP', JSON.stringify(data.data))

      if (window.location.search.match(/(\?|&)redirect\=([^&]*)/)) {
        var parameterValue = decodeURIComponent(window.location.search.match(/(\?|&)redirect\=(.*)/)[2]);
        subtitle.querySelector("a").href = '/estadio-aguila/iniciar-sesion?redirect=' + parameterValue
      }
      // console.log(subtitle.querySelector("a"))
    }
  }

  const validateUser = async () => {
    if (window.drupalSettings && window.drupalSettings.user.uid > 0) {
      if (sessionStorage.getItem("user-estadio")) {
        let userData = JSON.parse(sessionStorage.getItem("user-estadio"))
        if (userData.state.logged == true) {
          redirectUserLogged()
        }
      }
    } 
  }

  const redirectUserLogged = async () => {
    if (window.location.search.match(/(\?|&)redirect\=([^&]*)/)) {
      var parameterValue = decodeURIComponent(window.location.search.match(/(\?|&)redirect\=(.*)/)[2]);
      location.href = '/' + parameterValue
    }
    else {
      location.href = '/estadio-aguila'
    }
  }

  React.useEffect(() => {
    validateUser()
    showPass()
    // setValueDate()
    ValidateForm()
    gettpyc()

    document.addEventListener('bouncerFormValid', handleBouncerFormValidate, false);

    return () => {
      window.removeEventListener('bouncerFormValid', handleBouncerFormValidate);
    };
  }, [])
  
  const handleBouncerFormValidate = (event: any) => {
    let id = event.target.getAttribute('id')
    if (id == 'register') {
      setIsDisabledButton(true)
      submitRegistro(event.target)

      setTimeout(() => {
        setIsDisabledButton(false)
      }, 3000);
    }
  }

  const [fieldPhone, setFieldPhone] = React.useState("")
  
  const handleChangePhone = (event: any) => {
    const result = event.target.value.replace(/\D/g, '');
    
    setFieldPhone(result);
  };
  
  const [fieldSets, setFieldSet] = React.useState({ name: '', lastname: '', document: '' })
  
  const handleChange = (e: any) => {
    setIsDisabledButton(false)
    const isValid = e.target.validity.valid;
    let parent = e.target.closest('.row'),
      label = parent.querySelector('label')
    if (e.target.value.length >= 1) {
      label.classList.add('activeLabel')
    } else {
      label.classList.remove('activeLabel')
    }
    if (!isValid && e.target.value) return
    const { name, value } = e.target
    setFieldSet({ ...fieldSets, [name]: value })
  }

  const handdleClose = () => {
    // @ts-ignore
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Close Register',
      'interaction': 'true',
      'component_name': 'Register',
      'element_text': 'Cerrar Registro',
    });
    window.location.href = "/copa-america/predicciones"
  }

  return (
    <>
      <div className="pageRegister ar__content pageRegisterSingle" id="content-login">
        <a className="close__modal" onClick={handdleClose}></a>
        <div className={`ar__register ar__content__section register`} id="sectionRegister">
          <div className="ar__register__body">
            <a href="/estadio-aguila" className="logo logo-modal">
              <img src={`${defPath}/assets/images/login/escudo.png`} alt="Logo Aguila" />
            </a>
            <div className="ar__content__title">
              <h1 id="title-register" className="ar__login__title title_2 whiteShadow">Regístrate</h1>
              <div id="sub-register" className="ar__login__text black_24">
                <span className="whiteShadow">¿ya tienes cuenta?</span>
                <span>
                  <a className="yellow" href={urls.login} >Inicia Sesión</a>
                </span>
              </div>
            </div>
            <form id="register" className="ar__register__form">
              <div className="box-form">
                <div className="row">
                  <input required type="text" id="name" name="name" placeholder="Ingresa tu nombre" value={fieldSets.name} pattern="^[a-zA-ZáéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙñÑ\s]+$" onChange={handleChange} />
                  <label htmlFor="name" className="black_30 whiteShadow">Nombre</label>
                </div>
                <div className="row">
                  <input required type="text" id="lastname" name="lastname" placeholder="Ingresa tu apellido" value={fieldSets.lastname} pattern="^[a-zA-ZáéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙñÑ\s]+$" onChange={handleChange} />
                  <label htmlFor="lastname" className="black_30 whiteShadow">Apellido</label>
                </div>
                <div className="row">
                  <Input required type="email" id="email" name="email" placeholder="Ingresa tu correo electrónico" onChange={handleChange} />
                  <label htmlFor="email" className="black_30 whiteShadow">Correo electrónico</label>
                </div>
                {/* <div className="row">
                              <input required type="text" id="document" name="document" pattern="^[0-9\s]+$" placeholder="Ingresa tu documento" value={fieldSets.document} onChange={handleChange} />
                              <label htmlFor="document" className="black_30 whiteShadow">Documento</label>
                          </div> */}
                {/* <div className="row">
                  <input required type="date" name="date_birthday" id="date_birthday" onClick={handleClick} onKeyDown={e => e.preventDefault()}/>
                  <label htmlFor="date_birthday" className="black_30 whiteShadow">Fecha de nacimiento</label>
                </div> */}

                <div className="row">
                  <div className="column">
                    <div className="column-field">
                      <FieldSelect id="day" name="dia">
                        <option value="null">Dia</option>
                        {Array.from({ length: 31 }, (v, i) => 1 + i).map((day) => (<option key={day} value={day <= 9 ? `0${day}`: day}>{day}</option>))}
                      </FieldSelect>
                      <label htmlFor={"day"} className="black_30 whiteShadow" style={{width: 'max-content', left: "6rem"}}>Fecha de Nacimiento</label>
                    </div>
                    <div className="column-field">
                      <FieldSelect id="month" name="mes">
                        <option value="null">Mes</option>
                        <option value="01">Enero</option>
                        <option value="02">Febrero</option>
                        <option value="03">Marzo</option>
                        <option value="04">Abril</option>
                        <option value="05">Mayo</option>
                        <option value="06">Junio</option>
                        <option value="07">Julio</option>
                        <option value="08">Agosto</option>
                        <option value="09">Septiembre</option>
                        <option value="10">Octubre</option>
                        <option value="11">Noviembre</option>
                        <option value="12">Diciembre</option>
                      </FieldSelect>
                    </div>
                    <div className="column-field">
                      <FieldSelect id="year" name="año">
                        <option value="null">Año</option>
                        {Array.from({ length: 90 }, (v, i) => 2006 - i).map((year) => (<option key={year} value={year}>{year}</option>))}
                      </FieldSelect>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <input 
                    required
                    type="text" 
                    minLength={7} 
                    maxLength={10} 
                    id="phone" 
                    name="phone" 
                    pattern="^[0-9\s]+$" 
                    value={fieldPhone} 
                    onChange={handleChangePhone} 
                    placeholder="Ingresa tu teléfono de contacto" 
                  />
                  <label htmlFor="phone" className="black_30 whiteShadow">Teléfono</label>
                </div>

                {/* <div className="row">
                  <div className="column-field">
                    <FieldSelect id="gender" name="Género">
                      <option defaultValue={"true"} disabled></option>
                      <option value="masculino">Masculino</option>
                      <option value="femenino">Femenino</option>
                      <option value="prefiero no decir">Prefiero no decir</option>
                    </FieldSelect>
                    <label htmlFor={"gender"} className="black_30 whiteShadow">Género</label>
                  </div>
                </div> */}
                {/* <div className="row field-hidden">
                              <label htmlFor="password" className="black_30 whiteShadow">test</label>
                          </div> */}
                <div className="row">
                  <div className="passwordBox">
                    <Input required type="password" id="password" name="password" placeholder="Ingresa tu contraseña" autoComplete='password' />
                    <label htmlFor="password" className="black_30 whiteShadow">Contraseña</label>
                    <div className="eye"></div>
                  </div>
                </div>
                <div className="row">
                  <div className="passwordBox">
                    <Input required type="password" id="password_confirm" name="password_confirm" placeholder="Ingresa tu contraseña" autoComplete='password' />
                    <label htmlFor="password_confirm" className="black_30 whiteShadow">Confirmar Contraseña</label>
                    <div className="eye"></div>
                  </div>
                </div>
              </div>

              <div className="boxes-check">
                <div className="checkbox-box checkbox-box--tyc">
                  <div className="input-tyc">
                    <input type="checkbox" name="tyc" id="tyc" required />
                  </div>
                  <p className="medium_24" id="tyc-link"></p>
                </div>
                <div className="checkbox-box checkbox-box--tyc">
                  <div className="input-tyc">
                    <input type="checkbox" name="marketing" id="marketing" required />
                  </div>
                  <p className="medium_24" id="pyp"></p>
                </div>
                {/* <div className="checkbox-box">
                  <input type="checkbox" name="info" id="" />
                  <p className="medium_24">En caso de ser ganador deseo ser contactado y acepto recibir información, novedades y promociones de Aguila Estadium</p>
                </div> */}
              </div>
              <button id="btn-register" type="submit" className={`ar__btn ar__btn-primary ${isDisabledButton ? 'opacity': ''}`} onClick={sendDatalayerRegistro} disabled={isDisabledButton} >Registrarme</button>
              <div id="error-drupal" className="blur-in"></div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default App

type InputProps = InputHTMLAttributes<HTMLInputElement>

export function Input(props: InputProps) {
  const input = useRef<HTMLInputElement>(null)
  const [disabled, setDisabled] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setDisabled(false)
    }, 1000);
  }, [])
  
  return (
    <input ref={input} {...props} disabled={disabled} />
  )
}

function FieldSelect({ id, children }: any) {
  const [isFocused, setIsFocused] = useState(false)
  return (
    <>
      <select 
        id={id} 
        name={id} 
        onFocus={() => setIsFocused(true)} 
        onClick={() => setIsFocused(true)}
        required 
      >
        {/* {isFocused && <>{children}</>} */}
        {children}
      </select>
    </>
  )
}